import { useMemo } from 'react';

import { getTableOptions } from '../utils/tableOptions.ts';

export const useTableOptions = () => {
	return useMemo(() => getTableOptions(), []);
};
